export const CACHE_KEY_REQUEST_CANCEL = 'cancel-reject';
